import React from 'react';

/** Minimal product metadata below the purchase block. */
export default function ProductDetailsPanel({
  description,
  tags,
  sku,
  isExpanded,
  onToggleExpand,
}) {
  const tagList = tags ? tags.split(' ').filter(Boolean) : [];
  const hasContent = description || tagList.length > 0 || sku;

  if (!hasContent) return null;

  const longDescription = description && description.length > 200;

  return (
    <div className="border-t border-slate-100 bg-slate-50/30">
      {description && (
        <section className="px-3 py-2.5 sm:px-4">
          <h2 className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide mb-1">
            Product details
          </h2>
          <p
            className={`text-xs text-slate-600 leading-relaxed ${
              !isExpanded && longDescription ? 'line-clamp-3' : ''
            }`}
          >
            {description}
          </p>
          {longDescription && (
            <button
              type="button"
              onClick={onToggleExpand}
              className="text-[11px] font-medium text-brand-600 mt-1"
            >
              {isExpanded ? 'Show less' : 'Read more'}
            </button>
          )}
        </section>
      )}

      {(tagList.length > 0 || sku) && (
        <div
          className={`px-3 pb-2.5 sm:px-4 flex flex-wrap items-center gap-1.5 text-[10px] ${
            description ? 'border-t border-slate-100 pt-2' : 'pt-2.5'
          }`}
        >
          {tagList.map((tag, index) => (
            <span key={index} className="px-1.5 py-px rounded bg-white border border-slate-200 text-slate-600">
              {tag}
            </span>
          ))}
          {sku && (
            <span className="text-slate-400 font-mono ml-auto">SKU {sku}</span>
          )}
        </div>
      )}
    </div>
  );
}
